import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { announceTranscriptionLanguageSaga } from 'features/transcripts/sagas/announceTranscriptionLanguageSaga';
import { PermissionTypes } from 'features/permissions/types';
import {
  selectCaptionsApplyToAll,
  spokenLanguageChanged,
} from 'features/transcripts/slices/captions/captionsSlice';
import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { eventBus } from 'utils/eventBus';

export function* changeSpokenLanguageSaga(action: ReturnType<typeof spokenLanguageChanged>) {
  const { code, applyToAll } = action.payload;
  const storedApplyToAll: boolean = yield select(selectCaptionsApplyToAll);

  const canTranscribeSession: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.transcribeSession
  );

  const applyToAllValue = applyToAll !== undefined ? applyToAll : storedApplyToAll;
  const appliesToEveryone = applyToAllValue && canTranscribeSession;

  yield call(SignalingSocket.send, {
    event: 'changeSpokenLanguage',
    data: { code, applyToAll: appliesToEveryone },
  });

  yield call(eventBus.sendMessage, 'captionsSpokenLanguageChanged', {}, { language: code });

  // The server broadcasts a change back only when it applies to everyone, so a change the
  // participant made for themselves has to be announced here.
  if (!appliesToEveryone) {
    yield call(announceTranscriptionLanguageSaga, 'personal');
  }
}
